module.exports = __webpack_public_path__ + "img/goal-six-en.553fdba9.png";